var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJournalBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_73_15094",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 136,
    height: 136
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.52588e-05H136V136H0V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_73_15094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 119.797C68 110.601 74.6486 102.752 83.7197 101.24L117.406 95.8906V50.413",
    stroke: "#70C4F0",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.406 27.872V16.2031L83.7197 21.5528C74.6486 23.0642 68 30.9134 68 40.1094",
    stroke: "#70C4F0",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 119.797C68 110.601 61.3514 102.752 52.2803 101.24L18.5938 95.8906V16.2031L52.2803 21.5528C61.3514 23.0642 68 30.9134 68 40.1094V119.797Z",
    stroke: "#70C4F0",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.409 27.8748L119.741 25.5399C122.852 22.4265 127.898 22.4265 131.009 25.5399C132.566 27.0938 133.344 29.1336 133.344 31.1738C133.344 33.2138 132.566 35.2536 131.009 36.8077L102.635 65.1815L81.948 74.6006L91.3671 53.9137L117.409 27.8748Z",
    stroke: "#70C4F0",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3669 53.9138L102.635 65.1816",
    stroke: "#70C4F0",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.104 31.1739L125.375 42.4443",
    stroke: "#70C4F0",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.906 110.5C107.441 110.5 106.25 109.309 106.25 107.844C106.25 106.378 107.441 105.188 108.906 105.188C110.372 105.188 111.562 106.378 111.562 107.844C111.562 109.309 110.372 110.5 108.906 110.5Z",
    fill: "#70C4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5938 32.1406H2.65625V111.828H48.7608C55.9778 111.828 62.8973 114.694 68 119.797C73.1027 114.694 80.0222 111.828 87.2392 111.828H97.6358",
    stroke: "#70C4F0",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.177 111.828H133.344V31.1738",
    stroke: "#70C4F0",
    strokeWidth: 5.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalBlue);
export default __webpack_public_path__ + "static/media/journal-blue.55293ac0bb4fb33da36504ca4c260faa.svg";
export { ForwardRef as ReactComponent };